/**
 * logout.component.ts
 * Copyright © 2016-2018, My Coverage Plan, Inc.
 * All rights reserved.
 */

/**
 * @author Taylor DH Smith <tdsmith@safetyweb.org>
 */

import { Component, OnInit } from "@angular/core";
import { MessagingService } from "../server/messaging.service";

/**
 * A behaviorless component used as an endpoint for the {@link LogoutGuard}.
 */
@Component({
  template: `
  <div class="container">
  <div id="loginContainer" class="well center-block">
    <h2 class="text-center">You are now logged out.</h2>
  </div>
  </div>
  `,
  styles: ["#loginContainer { width: 400px; max-width: 90%;}"]
})
export class LogoutComponent implements OnInit
{
  constructor (private messaging : MessagingService)
  {
    // Nothing
  }

  public ngOnInit () : void
  {
    // the second `true` signals that this is user initiated and avoids
    // hitting the restart limit due to deliberate logouts
    this.messaging.restart(true, true);
  }

}



// WEBPACK FOOTER //
// ./~/angular-router-loader/src!./app/auth/logout.component.ts